import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FHIRResourceParam } from '@app/fhir-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onFHIRResourceParamsUpdated = new ThunderDispatcherV3('__onFHIRResourceParamsUpdated');
export class ModuleFE_FHIRResourceParam_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_FHIRResourceParam, dispatch_onFHIRResourceParamsUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_FHIRResourceParam = new ModuleFE_FHIRResourceParam_Class();
//# sourceMappingURL=ModuleFE_FHIRResourceParam.js.map